import type { ReactNode } from 'react';

interface SpinnerProps {
  /** Optional message shown below the spinner */
  message?: ReactNode;
  /** Size variant */
  size?: 'sm' | 'md' | 'lg';
  /** Center in the full viewport height */
  fullPage?: boolean;
}

const sizeClasses: Record<string, string> = {
  sm: 'w-5 h-5 border-2',
  md: 'w-8 h-8 border-3',
  lg: 'w-10 h-10 border-3',
};

export function Spinner({ message, size = 'md', fullPage = false }: SpinnerProps) {
  const wrapper = fullPage
    ? 'min-h-[calc(100vh-64px)] flex flex-col items-center justify-center'
    : 'flex flex-col items-center justify-center py-12';

  return (
    <div className={wrapper}>
      <div
        className={`${sizeClasses[size]} border-slate-600 border-t-helm-400 rounded-full animate-spin mb-3`}
      />
      {message && <div className="text-slate-400 text-sm">{message}</div>}
    </div>
  );
}
